import { createGlobalStyle } from 'styled-components';
import { Colors } from './constants';

export default createGlobalStyle`
* {
  margin:0;
  padding:0;
  outline:0;
  box-sizing: border-box;
}

body {
  background-color:#f0f0f5;
  min-height: 100vh;
  -webkit-font-smoothing: antialiased;
}

hmtl {
  min-height: 100vh;
}

@media print {
  body {
    background-color:transparent;
  }

  .p-print-0{
    padding:0;
  }
}

body, input, button {
  font: 14px Roboto, sans-serif;
}

button {
  cursor: pointer;
}

button:disabled {
  cursor: not-allowed;
}

.bg-verde{
  background-color:${Colors.verde};
}

.bg-verde-claro{
  background-color:${Colors.verdeClaro};
}

.text-verde{
  color:${Colors.verde};
}

.text-cinza{
  color:${Colors.cinza};
}
.text-line-through {
  text-decoration: line-through;
}

.text-verde-claro{
  color:${Colors.verdeClaro};
}

.bg-verde-gradiente{
  background-image: linear-gradient(to left, ${Colors.verdeClaro}, ${Colors.verde});
}

#root {
}
.table {
font-weight: normal;
}
.table thead{
  font-size: 13px;
}
.table th{
  height: 34px;
  vertical-align: middle!important;
  border-bottom-width: 0!important;
}
.table tbody{
  font-size: 12px;
}
.table td{
  vertical-align: middle!important;
}

.modal-body{
  padding-top: .5rem;
}

.modal-header{
  padding: .5rem 1rem;
}

.tabela .tabela-contrato{
    border-collapse:collapse;
}
.tabela .tabela-contrato td{
    border:1px solid #000;
    padding: 2px 8px;
}

`;
